export default [
  {
    path: '/salary/:key?',
    name: 'salaryPage',
    component: () => import(/*webpackChunkName:'salary'*/ '@/views/salary/index.vue'),
    meta: {},
  },
];
